import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      stroke: "#fff",
      "stroke-width": ".5",
      d: "M29.745 14.568H28v-3.15c0-.757-.613-1.373-1.366-1.373H25V8.832l-.247-.249h-.001l-3.648-3.667L17.207 1H5v5.528H2.366C1.613 6.528 1 7.144 1 7.9v21.953h.003a1.28 1.28 0 0 0 1.28 1.297h22.379c.578 0 1.087-.392 1.225-.911L31 16.15v-.089c0-.865-.528-1.493-1.255-1.493Zm-3.111-3.518c.201 0 .366.165.366.368v3.15h-2V11.05zM17.5 2.716l5.793 5.822H17.5zM6 2.005h10.5v7.538H24v5.025H7.366q-.108 0-.212.018c-.486.08-.893.438-1.013.893L6 15.867V2.005ZM2 7.901c0-.203.164-.368.366-.368H5v11.073l-3 8.223zm22.935 22.035a.28.28 0 0 1-.273.21H2.282a.28.28 0 0 1-.224-.112c-.031-.04-.08-.128-.061-.205L5 21.552v.002l2.08-5.73.013-.041a.28.28 0 0 1 .272-.21h22.38c.19 0 .238.274.251.412z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      stroke: "#fff",
      "stroke-width": ".5",
      d: "M9 9.543h5c.276 0 .5-.225.5-.503a.5.5 0 0 0-.5-.502H9a.501.501 0 0 0 0 1.005ZM9 6.025h5c.276 0 .5-.224.5-.502a.5.5 0 0 0-.5-.503H9c-.276 0-.5.225-.5.503s.224.502.5.502ZM9 13.06h12a.501.501 0 0 0 0-1.005H9c-.276 0-.5.225-.5.503s.224.502.5.502Z"
    }, null, -1)
  ]))]))
}
export default { render: render }